import { Drawer, Typography, Grid } from '@mui/material'
import { useState } from 'react'
import { HiPlus } from 'react-icons/hi'
import { Button, TextField, Fab, Box, IconButton, Loading } from 'components'
import { useDebounce } from 'utils'
import { ProductItemList } from './ProductItemList'
import { useLoadOrderProducts } from 'modules/orders/hooks'
import { MdKeyboardArrowLeft, MdSearch } from 'react-icons/md'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { useItemFormDrawerStore } from '../ItemForm/itemFormDrawerStore'
import { useFormContext } from 'react-hook-form'

export type ListDrawerProp = {
  onSelect: any
}

export const ListDrawer = ({ onSelect }: ListDrawerProp) => {
  const [isNewItemOpen, setIsNewItemOpen] = useState(false)
  const setSelectedItem = useItemFormDrawerStore.useSetSelectedItem()
  const setItemMode = useItemFormDrawerStore.useSetItemMode()
  const [search, setSearch] = useState('')

  const { watch } = useFormContext()

  const unity = watch('unity')

  const searchDebounced = useDebounce(search, 250)

  const {
    data: products,
    isLoading: productsLoading,
    isFetching: productsFetching
  } = useLoadOrderProducts({
    // page: 1,
    // limit: 100,
    search: searchDebounced,
    unityId: unity?.id || ''
  })

  const handleSearch = (event: any) => {
    setSearch(event.target.value.toUpperCase())
  }

  // verifica itens que estão no pedido e remove da listagem de itens a serem adicionados
  // const productsList =
  //   products?.data?.filter(
  //     (ele: any) =>
  //       !form?.orderItems?.some(
  //         (item: any) => item.product.id === ele.product.id
  //       )
  //   ) || []

  return (
    <>
      <Button
        startIcon={<MdSearch size={18} type="button" />}
        onClick={() => setIsNewItemOpen(true)}
      >
        Procurar produto
      </Button>
      {/* <Button
        type="button"
        onClick={() => setIsNewItemOpen(true)}
        size="small"
        sx={{
          display: { md: 'flex', sm: 'none', xs: 'none' }
        }}
        startIcon={<HiPlus size={18} />}
      >
        Adicionar Item
      </Button> */}

      <Box
        sx={{
          margin: 0,
          top: 'auto',
          right: 20,
          bottom: 80,
          left: 'auto',
          position: 'fixed',
          display: { md: 'none' },
          zIndex: 10
        }}
      >
        <Fab
          style={{ background: '#023770' }}
          onClick={() => setIsNewItemOpen(true)}
        >
          <HiPlus size={24} color="white" />
        </Fab>
      </Box>
      <Drawer anchor="right" open={isNewItemOpen} onClose={setIsNewItemOpen}>
        <div
          style={{
            maxWidth: 516,
            position: `sticky`,
            top: 0,
            backgroundColor: 'white',
            padding: 8
          }}
        >
          <Grid container spacing={2}>
            <Grid container item alignItems="center" xs={12}>
              <Grid item>
                <IconButton onClick={() => setIsNewItemOpen(false)}>
                  <MdKeyboardArrowLeft
                    size={24}
                    color="#565656"
                    style={{ background: '' }}
                  />
                </IconButton>
              </Grid>
              <Grid item>
                <Typography style={{ marginLeft: `1rem` }} variant="h6">
                  Selecione um item
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                placeholder="Pesquisar..."
                style={{ width: '100%' }}
                onChange={handleSearch}
                value={search}
                type="search"
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ padding: 8, maxWidth: 508, height: '100%' }}>
          {(productsLoading || productsFetching) && <Loading />}
          {!products?.data?.length &&
            !(productsLoading || productsFetching) && (
              <div>Nenhum item encontrado!</div>
            )}

          <AutoSizer>
            {({ height, width }) => (
              <List
                height={height}
                width={width}
                itemCount={products?.data?.length || 0}
                itemSize={110}
              >
                {({ index, style }: any) => (
                  <ProductItemList
                    key={products?.data?.[index]?.id}
                    item={products?.data?.[index]}
                    style={style}
                    onClick={() => {
                      setSelectedItem(products?.data?.[index])
                      setItemMode('new')
                      onSelect({
                        ...products?.data?.[index],
                        sequence: index + 1
                      })
                    }}
                  />
                )}
              </List>
            )}
          </AutoSizer>
        </div>
      </Drawer>
    </>
  )
}
